module.exports = "<div class=\"col-lg-4\">\n  <div class=\"sidenav\">\n    <a include=recent_posts></a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/blog/blog-post/blog-sidenav/blog-sidenav.component.html
// module id = ./src/app/components/blog/blog-post/blog-sidenav/blog-sidenav.component.html
// module chunks = main